class ElementNotFoundError extends Error {
	constructor(...args) {
		super(...args);
		Error.captureStackTrace(this, ElementNotFoundError);
	}
}
